import React from "react";
import { ValueTable } from "./ValueTable";
import { getSaleRowData, saleTableHeaders } from "./tableConfig";
import { SaleData } from "./types";

interface SaleTableProps {
    saleData: SaleData;
    type: "simple" | "leasedFee";
}

export const SaleTable: React.FC<SaleTableProps> = ({ saleData }) => {
    const mainRow = getSaleRowData(saleData);
    const totalRow = ["Total", ...mainRow.slice(1)];

    return (
        <ValueTable
            title={saleData.title}
            headers={saleTableHeaders}
            rows={[mainRow, totalRow]}
            data={saleData}
        />
    );
};
